<div class="flex flex-column w-9 m-auto gap-2">
    <h1>Página no encontrada</h1>
    <p>La página que buscas no está disponible :(</p>
    <p>Pero puedes seguir explorando mas opciones de Escorts en Colombia en nuestras secciones más populares:</p>
    <a [routerLink]="navigateTo('a-domicilio')">Ver Escorts a Domicilio</a>
    <a [routerLink]="navigateTo('baratas')">Ver Escorts Baratas</a>
    <a [routerLink]="navigateTo('nuevas-recientes')">Ver Escorts Recién Llegadas</a>
</div>